var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerticalHands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 253.797,
    height: 521.076,
    viewBox: "0 0 253.797 521.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 253.797,
    height: 521.076,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 -0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M639.628,35.141A33.641,33.641,0,1,1,605.987,1.5a33.641,33.641,0,0,1,33.641,33.641",
    transform: "translate(-432.593 -1.133)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 33.641,
    cy: 33.641,
    r: 33.641,
    transform: "translate(132.923 59.019) rotate(-76.718)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M768.965,220.506l-26.359,14.158-26.359,14.157.919-29.906.919-29.906,25.44,15.748Z",
    transform: "translate(-541.358 -142.858)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M768.965,220.506l-26.359,14.158-26.359,14.157.919-29.906.919-29.906,25.44,15.748Z",
    transform: "translate(-541.358 -142.858)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M211.562,1133.906l-28.5,40.852h99.415l22.942-40.467Z",
    transform: "translate(-138.36 -857.034)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M508.757,1134.875l-9.663,14.545h27.374l9.038-14.432Z",
    transform: "translate(-377.228 -857.766)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M508.757,1134.875l-9.663,14.545h27.374l9.038-14.432Z",
    transform: "translate(-377.228 -857.766)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 31.306,
    transform: "translate(90.995 280.922)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 22.877,
    transform: "translate(95.948 286.527)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 24.593,
    transform: "translate(91.451 291.089)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M311.472,1227.939H230.393l11.862-16.946h79.254Z",
    transform: "translate(-174.137 -915.298)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M311.472,1227.939H230.393l11.862-16.946h79.254Z",
    transform: "translate(-174.137 -915.298)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M1.5,441.989s53.954,24.169,57.7,29.651-2.3,14.552-2.273,20.86c.027,5.676,3.794,10.965.535,13.271-3.558,2.518-37.706-6.529-55.225-10.33",
    transform: "translate(-1.134 -334.066)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M229.945,595.977s35.8,24.819,39.277,20.464-5.75-12.093-5.75-12.093,21.8,16.982,24.6,10.7-18.052-18.052-18.052-18.052,30.353,12.034,31.156,5.349-24.2-13.1-24.2-13.1,20.993,4.012,21.528-1.471-32.226-11.9-32.226-11.9,15.11-4.145,13.907-8.978-15.244-1.586-23.267-.416-25.727-1.8-25.727-1.8c2.447,5.359-1.334,12.6-2.35,18.325-.7,3.942.245,7.641,1.1,12.982",
    transform: "translate(-172.78 -426.526)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M229.945,595.977s35.8,24.819,39.277,20.464-5.75-12.093-5.75-12.093,21.8,16.982,24.6,10.7-18.052-18.052-18.052-18.052,30.353,12.034,31.156,5.349-24.2-13.1-24.2-13.1,20.993,4.012,21.528-1.471-32.226-11.9-32.226-11.9,15.11-4.145,13.907-8.978-15.244-1.586-23.267-.416-25.727-1.8-25.727-1.8c2.447,5.359-1.334,12.6-2.35,18.325C228.142,586.936,229.087,590.636,229.945,595.977Z",
    transform: "translate(-172.78 -426.526)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M306.252,638.7s5.19,3.306,12.912-4.918",
    transform: "translate(-231.473 -479.025)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M359.648,1833.15s-38.6-1.787-37.549,25.261c.7,18.068,35.835,8.8,36.761,14.943,1.644,10.909-30.261,10.386-34.744,11.133-2.95.492-.374,8.646,1.345,8.368,2.411-.39,49.986-1.27,46.174-22.042-3.066-16.707-34.443-2.092-34.876-13.6-.488-12.994,22.663-10,22.663-10Z",
    transform: "translate(-243.435 -1385.521)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M359.648,1833.15s-38.6-1.787-37.549,25.261c.7,18.068,35.835,8.8,36.761,14.943,1.644,10.909-30.261,10.386-34.744,11.133-2.95.492-.374,8.646,1.345,8.368,2.411-.39,49.986-1.27,46.174-22.042-3.066-16.707-34.443-2.092-34.876-13.6-.488-12.994,22.663-10,22.663-10Z",
    transform: "translate(-243.435 -1385.521)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x1: 6.127,
    y2: 78.005,
    transform: "translate(97.643 442.704)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 5.593,
    y2: 78.005,
    transform: "translate(103.855 442.704)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 31.238,
    cy: 31.238,
    r: 31.238,
    transform: "translate(178.015 234.771) rotate(-45)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 22.125,
    cy: 22.125,
    r: 22.125,
    transform: "translate(199.56 213.166) rotate(-1.332)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 10.775,
    cy: 10.775,
    r: 10.775,
    transform: "translate(208.115 240.602) rotate(-67.5)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x2: 52.811,
    y2: 14.367,
    transform: "translate(169.604 220.732)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M682.628,873.682l-9.45,8.521L657.6,878.058l7.905-8.639L662.086,858.6l15.582,4.145Z",
    transform: "translate(-497.027 -648.953)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M562.691,1600.409s-35.7-45.831-39.714-48.94-26.23-21.361-21.461-27.479c4.555-5.844,17.843,10.645,25.257,14.441,5.911,3.026,12.065-.5,24.92-9.193,9.632-6.512,12.461-8.19,14.174-5.994,3.009,3.855-9.688,8.562-8.825,17.427,1.231,12.649,37.842,39.112,37.842,39.112",
    transform: "translate(-378.554 -1150.615)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M562.691,1600.409s-35.7-45.831-39.714-48.94-26.23-21.361-21.461-27.479c4.555-5.844,17.843,10.645,25.257,14.441,5.911,3.026,12.065-.5,24.92-9.193,9.632-6.512,12.461-8.19,14.174-5.994,3.009,3.855-9.688,8.562-8.825,17.427,1.231,12.649,37.842,39.112,37.842,39.112",
    transform: "translate(-378.554 -1150.615)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M605.632,1562.011s-9.959-23.581-5.175-26.208c4.6-2.524,21.528,21.061,22.464,40.683",
    transform: "translate(-452.857 -1160.656)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M605.632,1562.011s-9.959-23.581-5.175-26.208c4.6-2.524,21.528,21.061,22.464,40.683",
    transform: "translate(-452.857 -1160.656)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M694.658,1706.546s17.037-12.46,25.595-19.346l9.08,7.837s-18.4,16.507-25.677,22.927Z",
    transform: "translate(-525.04 -1275.227)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M694.658,1706.546s17.037-12.46,25.595-19.346l9.08,7.837s-18.4,16.507-25.677,22.927Z",
    transform: "translate(-525.04 -1275.227)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M639.223,1494.872c1.921-12.618,5.3-18.054,8.605-24.643,1.882-3.75,1.234-11.292-3.45-8.992-9.862,4.843-13.328,21.756-13.328,21.756Z",
    transform: "translate(-476.963 -1104.115)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M639.223,1494.872c1.921-12.618,5.3-18.054,8.605-24.643,1.882-3.75,1.234-11.292-3.45-8.992-9.862,4.843-13.328,21.756-13.328,21.756Z",
    transform: "translate(-476.963 -1104.115)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M664.52,1515.631c.45-8.523,9.864-30.536,12.752-26.968,3.41,4.212-6.117,24.028-6.117,24.028",
    transform: "translate(-502.26 -1124.875)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M664.52,1515.631c.45-8.523,9.864-30.536,12.752-26.968,3.41,4.212-6.117,24.028-6.117,24.028",
    transform: "translate(-502.26 -1124.875)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M683.813,1766.005l9.092,11.527-2.3,1.829a3.209,3.209,0,0,1-4.508-.519l-5.1-6.5a3.209,3.209,0,0,1,.519-4.508Z",
    transform: "translate(-514.183 -1334.79)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M683.813,1766.005l9.092,11.527-2.3,1.829a3.209,3.209,0,0,1-4.508-.519l-5.1-6.5a3.209,3.209,0,0,1,.519-4.508Z",
    transform: "translate(-514.183 -1334.79)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M680.294,1587.826s4.657-3.2,8.4-2.207",
    transform: "translate(-514.183 -1198.304)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M680.294,1587.826s4.657-3.2,8.4-2.207",
    transform: "translate(-514.183 -1198.304)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalHands);
export default __webpack_public_path__ + "static/media/vertical_hands.1dce5d2eca9acbb561edf098efd66c29.svg";
export { ForwardRef as ReactComponent };